import {ActiveConstants} from "finhelper";
import {NotifyManager} from "notify-component";
import Pusher from 'pusher-js';

import {CRM_PUSHER_APP_KEY, CRM_PUSHER_CLUSTER} from "#app/api/middleware/crmPusherConfig";
import * as jobsActions from "#app/store/actions/jobs";

const PENDING = 0;
const STARTED = 1;
const PROCESSING = 2;
const FINISHED = 3;
const FAILED = 4;

function getTextByType(type) {
  switch(parseInt(type))
  {
    case ActiveConstants.ZENMONEY:
      return 'Синхронизация с Дзенмани';
    case ActiveConstants.TINKOFF:
      return 'Синхронизация с "Тинькофф инвестиции"';
    case ActiveConstants.GOAL:
      return 'Идёт перерассчёт целей';
    case ActiveConstants.STRATEGY:
      return 'Идёт рассчёт графика';
    case ActiveConstants.GOAL_RECALC:
      return 'Идёт перерассчёт целей';
    case ActiveConstants.ATON_CRM_PARSE:
      return 'Загрузка контактов из CRM атона';
  }
}

async function pending(store, job) {
  let state = store.getState();

  if (typeof state.jobs[job.job_id] === 'undefined') {
    NotifyManager.loadingOnce(job.job_id, '', getTextByType(job.type_id) + ', задача в очереди на выполнение.');
    // redux-act action creators возвращают action object при вызове
    const action = jobsActions.handleCreateJob(job.job_id);
    store.dispatch(action);
  }
}

async function started(store, job) {
  let state = store.getState();

  if (typeof state.jobs[job.job_id] === 'undefined') {
    NotifyManager.loadingOnce(job.job_id, '', getTextByType(job.type_id));
    // redux-act action creators возвращают action object при вызове
    const action = jobsActions.handleCreateJob(job.job_id);
    store.dispatch(action);
  }
}

async function failed(store, job) {
  let state = store.getState();

  if (typeof state.jobs[job.job_id] !== 'undefined') {
    NotifyManager.error('Ошибка', 'Произошла ошибка при выполнении операции');
    NotifyManager.delete(job.job_id);
    // redux-act action creators возвращают action object при вызове
    const action = jobsActions.handleRemoveJob(job.job_id);
    store.dispatch(action);
  }
}

async function processing(store, job) {
  let state = store.getState();

  if (typeof state.jobs[job.job_id] === 'undefined') {
    NotifyManager.loadingOnce(job.job_id, '', getTextByType(job.type_id));
    // redux-act action creators возвращают action object при вызове
    const action = jobsActions.handleCreateJob(job.job_id);
    store.dispatch(action);
    NotifyManager.update(job.job_id, parseFloat(job.percent));
  } else {
    NotifyManager.update(job.job_id, parseFloat(job.percent));
  }
}

async function finished(store, job) {
  let state = store.getState();

  if (typeof state.jobs[job.job_id] !== 'undefined') {
    NotifyManager.info('Успешно', 'Операция завершена');
    NotifyManager.delete(job.job_id);
    // redux-act action creators возвращают action object при вызове
    const action = jobsActions.handleRemoveJob(job.job_id);
    store.dispatch(action);
  }
}

const eventQueue = [];
let isProcessingQueue = false;

export function enqueueEvent(store, job) {
  return new Promise((resolve) => {
    eventQueue.push({ store, job, resolve });
    processQueue();
  });
}

async function processQueue() {
  if (isProcessingQueue) return;
  isProcessingQueue = true;

  while (eventQueue.length > 0) {
    const { store, job, resolve } = eventQueue.shift();

    if (job.status) {
      switch (job.status) {
        case PENDING:
          await pending(store, job);
          break;
        case STARTED:
          await started(store, job);
          break;
        case PROCESSING:
          await processing(store, job);
          break;
        case FAILED:
          await failed(store, job);
          break;
        case FINISHED:
          await finished(store, job);
          break;
      }
    }
    resolve();
  }

  isProcessingQueue = false;
}

const socketMiddleware = () => {
  let pusher = null;
  let jobsChannel = null;

  return store => next => action => {
    switch (action.type) {
      case 'SOCKETS_CONNECTING': {
        const api_token = localStorage.getItem('api_token');
        const headers = { 'Authorization': api_token };

        if (!pusher) {
          pusher = new Pusher(CRM_PUSHER_APP_KEY, {
            cluster: CRM_PUSHER_CLUSTER,
            channelAuthorization: {
              endpoint: process.env.REACT_APP_API_URL + "/broadcasting/auth",
              transport: "ajax",
              headers: headers,
              customHandler: null,
            },
          });

          jobsChannel = pusher.subscribe('private-jobs-' + process.env.REACT_APP_ENV + '-' + action.payload.role + '-' + action.payload.userId);
          jobsChannel.bind('jobs', (job) => {
            enqueueEvent(store, job);
          });
        }

        break;
      }

      case 'SOCKETS_DISCONNECTING':
        if (pusher) {
          if (jobsChannel) {
            jobsChannel.unbind_all();
            jobsChannel.unsubscribe();
            jobsChannel = null;
          }
          pusher.disconnect();
          pusher = null;
        }
        break;

      default:
        return next(action);
    }
  };
};

export default socketMiddleware();